import React, {Component} from 'react';
import {connect} from 'react-redux';
import cookie from 'react-cookies';
import {
	changeCurrentPath,
	fetchUser,
	resetMainListState,
	resetConsigneeListStateNew,
	clickAgreeTerms,
	clickLogout,
	fetchInformationList,
	completeResetPassword
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress';
import SpNav from '../../common/containers/sp_nav';
import Footer from '../../common/containers/footer';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import ErrorDialog from '../../common/components/dialog/error-dialog';

import Login from './components/login';
import ResetForm from "./components/reset-form";
import ResetCompleteForm from "./components/reset-complete-form";
import Viewer from './components/viewer';
import DetailViewer from '../information/components/detail-viewer';

import {getApiUrl} from '../../sagas/index';
import {releaseMode} from '../../common/const';


class Menu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			IsLogin: false,
			IsProcess: false,
			detailData: {},
			detailIndex: null,
			statisticsErrorOpen: false,
			showResetForm: false,
			jigyousha_cd: '',
			user_id: '',
			showResetCompleteForm: false,
		}
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {auth, dispatch} = this.props;

		if (!auth.isLoggedIn) {
			const jigyousha_cd = cookie.load('jigyousha_cd');
			const user_id = cookie.load('user_id');
			const password = cookie.load('password');
			const SessionID = cookie.load('SessionID');
			if (jigyousha_cd && user_id && password && SessionID) {
				this.props.dispatch(fetchUser({
					jigyousha_cd,
					user_id,
					password,
					auto_login: true,
					SessionID
				}));
			}
		}
		dispatch(fetchInformationList());
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}


	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.auth.isCompleteResetSend) {
			this.setState({
				showResetForm: false,
				showResetCompleteForm: true
			});
		}
	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	/** event handlers **/
	handleClickMainList = () => {
		this.props.history.push('/main-list');
	};
	handleClickConsigneeList = () => {
		this.props.history.push('/consignee-list');
	};
	handleClickConsigneeListNew = () => {
		this.props.history.push('/consignee-list-new');
	};
	handleClickReceiptList = () => {
		this.props.history.push('/receipt-list');
	};
	handleClickArrivalList = () => {
		this.props.history.push('/arrival-list');
	};
	handleClickStatistics = () => {
		if (this.props.auth.user.IsStatisticsOptionAvailable) {
			this.props.history.push('/statistics');
		} else {
			this.setState({
				statisticsErrorOpen: true
			});
		}
	};
	handleClickShipment = () => {
		this.props.history.push('/shipment');
	};
	handleClickEntryList = () => {
		this.props.history.push('/entry-list');
	}
	handleClickDeliveryStatusList = () => {
		this.props.history.push('/delivery-status-list');
	};
	handleClickDeleteList = () => {
		this.props.history.push('/delete-list');
	};
	handleClickUploadReceiptList = () => {
		this.props.history.push('/upload-receipt');
	};
	handleClickBanner = (event) => {
		event.preventDefault();
		window.open('https://form.run/@hacobell-tsunagte', '_blank');
	};
	handleClickAgree = () => {
		const {SessionID, termsVersion} = this.props.auth;
		this.props.dispatch(clickAgreeTerms({
			termsVersion,
			SessionID
		}));
	};
	handleClickCloseTerms = () => {
		this.props.dispatch(clickLogout());
	};

	handleClickContents = (detailData, index) => {
		this.setState({
			detailData,
			detailIndex: index
		})
	};

	handleClickCloseDetails = () => {
		this.setState({
			detailData: {},
			detailIndex: null
		})
	};

	handleClickBeforeDetails = () => {
		const detailData = this.props.infoSettings.data[this.state.detailIndex - 1];
		this.setState({
			detailData,
			detailIndex: this.state.detailIndex - 1
		})

	};

	handleClickNextDetails = () => {
		const detailData = this.props.infoSettings.data[this.state.detailIndex + 1];
		this.setState({
			detailData,
			detailIndex: this.state.detailIndex + 1
		})

	};

	handleClickTest = (event) => {
		event.preventDefault();
		window.open(getApiUrl() + 'test');
	};


	handleCloseStatisticsError = () => {
		this.setState({
			statisticsErrorOpen: false
		});
	};

	hendleOpenResetForm = (jigyousha_cd, user_id) => {
		this.setState({
			showResetForm: true,
			jigyousha_cd,
			user_id
		});
	}
	handleCloseResetForm = () => {
		this.setState({
			showResetForm: false
		});
	}
	handleCloseResetCompleteForm = () => {
		this.setState({
			showResetCompleteForm: false
		});
		this.props.dispatch(completeResetPassword({
			isCompleteResetSend: false
		}))
	}


	render() {
		const auth = this.props.auth;

		const {data} = this.props.infoSettings;

		const informationData = data.slice(0, 3);

		const {detailData, detailIndex, statisticsErrorOpen} = this.state;
		const openDetail = !(Object.keys(detailData).length) ? false : true;

		const hasBefore = openDetail && detailIndex !== 0 && informationData.length > 1;
		const hasNext = openDetail && detailIndex !== informationData.length - 1 && informationData.length > 1;


		const detailInner = informationData.map((dt, index) => {
			return (
				<li key={index}>
					<dl>
						<dt>{dt.date}</dt>
						<dd className={"category_dt"}>{dt.cat}</dd>
						<dd className={"contents_dd"}><span
							onClick={this.handleClickContents.bind(this, dt, index)}>{dt.title}</span></dd>
					</dl>
				</li>

			);
		});

		const limitText = <span>ここからは有料サービスです。（月額利用料　5,000円 税抜）<br/>
			サービスの詳細、お試し利用、ご契約等に関するお問い合わせは下記宛先にご連絡下さい。<br/>
			<br/>
			(株)TSUNAGUTE　担当者宛<br/>
			<a href="mailto:sales@tsunagute.co.jp">sales@tsunagute.co.jp</a></span>;

		const {
			IsStatisticsOptionAvailable,
			IsNiukeshoOptionAvailable,
			IsMainOptionAvailable,
			IsArrivalOptionAvailable,
			IsIfmtOptionAvailable,
			IsEntryOptionAvailable,
			IsDeliveryStatusOptionAvailable,
			JigyoushaIsReceipt,
			JigyoushaIsChoai,
		} = auth.user;
		return (
			<div id="main_container">
				{auth.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					{auth.isLoggedIn && !auth.todoAgree && [
						<section id="top_navigation" key={"navigation"}>
							<ul>
								{IsMainOptionAvailable &&
								<li onClick={this.handleClickMainList}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/slips.png" alt="伝票印刷"/>
									</div>
									伝票印刷
								</li>
								}
								{releaseMode() <= 3 && IsArrivalOptionAvailable &&
								<li onClick={this.handleClickArrivalList}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/arrival.png" alt="着荷確認"/>
									</div>
									着荷確認
								</li>
								}
								{releaseMode() <= 3 && IsNiukeshoOptionAvailable &&
								<li onClick={this.handleClickConsigneeListNew}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/consignee.png" alt="荷受確認"/>
									</div>
									荷受確認
								</li>
								}
								{releaseMode() <= 3 && (JigyoushaIsReceipt || JigyoushaIsChoai) &&
								<li onClick={this.handleClickReceiptList}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/receipt.png" alt="電子受領"/>
									</div>
									電子受領
								</li>
								}
								{releaseMode() <= 3 && IsStatisticsOptionAvailable &&
								<li onClick={this.handleClickStatistics}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/statistics.png" alt="統計情報"/>
									</div>
									統計情報
								</li>
								}
								{releaseMode() <= 3 && IsIfmtOptionAvailable &&
								<li onClick={this.handleClickShipment}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/shipment.png" alt="車番登録"/>
									</div>
									車番登録
								</li>
								}
								{releaseMode() <= 3 && IsEntryOptionAvailable &&
								<li onClick={this.handleClickEntryList}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/entry.png" alt="伝票登録"/>
									</div>
									伝票登録
								</li>
								}
								{releaseMode() <= 3 && IsDeliveryStatusOptionAvailable &&
								<li onClick={this.handleClickDeliveryStatusList}>
									<div className="img_wrap hover_txt">
										<img src="/images/icon/delivery.png" alt="納品状況照会"/>
									</div>
									納品状況照会
								</li>
								}
							</ul>
						</section>,
						<section className="main_menu_sub_title" key={"info_title"}>
							<h2>新着情報</h2>
						</section>,
						<section id="information_list" key={"info_list"}>
							{informationData.length ?
								<ul>
									{detailInner}
								</ul>
								:
								<p>現在お知らせはありません</p>
							}
						</section>
					]
					}
				</article>
				{!auth.isLoggedIn && !this.state.showResetForm && !this.state.showResetCompleteForm &&
				<Login
					openResetFormFunc={this.hendleOpenResetForm}
				/>
				}
				{this.state.showResetForm &&
				<ResetForm
					backLoginFunc={this.handleCloseResetForm}
					jigyousha_cd={this.state.jigyousha_cd}
					user_id={this.state.user_id}
				/>
				}
				{this.state.showResetCompleteForm &&
				<ResetCompleteForm
					backLoginFunc={this.handleCloseResetCompleteForm}
				/>
				}
				{auth.todoAgree &&
				<Viewer
					filePath={auth.termsFilePath}
					afterOkFunc={this.handleClickAgree}
					afterCloseFunc={this.handleClickCloseTerms}
				/>
				}
				<Footer/>
				{auth.isLoggedIn && !auth.todoAgree &&
				<LogoutModal/>
				}
				<ReloadModal/>
				<ErrorDialog
					open={statisticsErrorOpen}
					title={'ご利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseStatisticsError}
				/>
				{openDetail &&
				<DetailViewer
					title={detailData.title}
					date={detailData.date}
					cat={detailData.cat}
					contents={detailData.contents}
					afterCloseFunc={this.handleClickCloseDetails}
					clickBeforeFunc={this.handleClickBeforeDetails}
					clickNextFunc={this.handleClickNextDetails}
					hasBefore={hasBefore}
					hasNext={hasNext}
				/>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		infoSettings: state.informationSettings

	};
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/routes/menu/index.js